

const extractTextFromDraftString = (content) => {
  const parsedContent = JSON.parse(content) 
  // toWellFormed replaces lone surrogates with replacement char (e.g. emoji that only has its first code point)
  const textBlocks = parsedContent.blocks.map(({text}) => (text ).toWellFormed())
  return textBlocks.join('\n')
}

export default extractTextFromDraftString
